import { Tabs } from 'common/constants';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { ReconciliationReportPage } from 'pages/ReconciliationReportPage';
import { useAppSelector } from 'store/hooks';
import { VendorsTable, PrintChecks } from './components';

export const VendorsTablePage = (): React.JSX.Element => {
  const selectedTab = useAppSelector(getSelectedTab);
  let selectedComponent;
  switch (selectedTab) {
    case Tabs.ReconcileCreditCards:
      selectedComponent = <ReconciliationReportPage />;
      break;
    case Tabs.PrintChecks:
      selectedComponent = <PrintChecks />;
      break;
    case Tabs.NeedsAuthorization:
    case Tabs.ToBePaid:
    default:
      selectedComponent = <VendorsTable />;
  }
  return selectedComponent;
};
